import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import SectionContent from "../../../components/sectionContent/sectionContent";
import Signals from "../../../pages/tunder/signals/signals";
import Sidebar from "../../../components/sidebar/Sidebar";

import "../../../scss/App.scss";
import { IUserOptions } from "../../../types/interfaces";
import HeaderBtn from "../../../components/headerBtn/headerBtn";

const SignalsApp = () => {
  const { claims } = useSelector((state: IUserOptions) => state.user.user.data);

  return (
    <div className="App">
      <Sidebar />
      <SectionContent section="Тандер" title="Сигналы" headBlockChildren={
          <>
            {(claims.includes("admin") || claims.includes("tander:view")) && (
              <HeaderBtn
                content="Выгрузить список"
                purpose="signalsDownload"
                modalTitle="Список сигналов"
              />
            )}
          </>
        }>
        <div className="content__main">
          <div className="btns">
            {(claims.includes("admin") || claims.includes("tander:view")) && (
              <Link to="/tunder/shops" className="tab">
                <div className="buttons__btn">Торговые точки</div>
              </Link>
            )}
            {(claims.includes("admin") || claims.includes("tander:view")) && (
              <Link to="/tunder/signals" className="tab">
                <div className="buttons__btn --active">Сигналы</div>
              </Link>
            )}
            {(claims.includes("admin") ||
              claims.includes("tander:settings")) && (
              <Link to="/tunder/properties" className="tab">
                <div className="buttons__btn">Настройки</div>
              </Link>
            )}
            <Link to="/tunder/goods" className="tab">
              <div className="buttons__btn">Товары</div>
            </Link>
            {(claims.includes("admin") ||
              claims.includes("tander:settings")) && (
              <Link to="/tunder/access" className="tab">
                <div className="buttons__btn">Доступы</div>
              </Link>
            )}
          </div>
          <Signals />
        </div>
      </SectionContent>
    </div>
  );
};

export default SignalsApp;
